<template>
  <EditarReciboComponent :recibo_id="recibo.id" @guardado="volver()"></EditarReciboComponent>
</template>
<script>
//import Conceptos from '@/models/concepto'
import EditarReciboComponent from "@/components/views/recibo/EditarReciboComponent";
export default {
  name: "EditarRecibo",
  components: {
    EditarReciboComponent,
  },
  data() {
    return {
      recibo: {},
      abrirSeleccionarConcepto: false,
      searching: true,
      conceptoSeleccionado: [],
    };
  },
  created() {
    this.recibo.id = this.$route.params.id;
  },
  mounted() {},
  methods: {
    volver(){
      this.$router.go(-1)
    }
  },
};
</script>